import { DictContext } from "@/layout/context/DictContext";
import { Button, Flex, Input, notification, Typography } from "antd";

import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PDFGenerator from "@/pages/Purchase/pages/Order/components/PrintOrderList";
import previewPurData from "@/utils/previewPurData";
import { PurchaseRuleBox } from "./style";
import { UserLangEnum } from "@/types/user";
import { DictEnum, DictInfo, DictInfoVal } from "@/types/dict";
import { addVal, updateVal } from "@/apis/dict";


const PurchaseRules: React.FC = () => {
  const { t } = useTranslation();

  const { purchaseRule, setPurchaseRule } = useContext(DictContext);
  const [dataList, setDataList] = useState<Array<{ key: UserLangEnum, text: string }>>([]);
  const [loading, setLoading] = useState<UserLangEnum | undefined>(undefined);


  useEffect(() => {
    if (dataList.length === 0) {
      let zhRule = purchaseRule.find(p => p.key === UserLangEnum.ZH);
      let trRule = purchaseRule.find(p => p.key === UserLangEnum.TR);
      let koRule = purchaseRule.find(p => p.key === UserLangEnum.KO);
      let enRule = purchaseRule.find(p => p.key === UserLangEnum.EN);
      let vnRule = purchaseRule.find(p => p.key === UserLangEnum.VN);
      setDataList([
        { key: UserLangEnum.ZH, text: zhRule?.value ?? '' },
        { key: UserLangEnum.TR, text: trRule?.value ?? '' },
        { key: UserLangEnum.KO, text: koRule?.value ?? '' },
        { key: UserLangEnum.EN, text: enRule?.value ?? '' },
        { key: UserLangEnum.VN, text: vnRule?.value ?? '' },
      ])
    }
  }, [purchaseRule, dataList]);

  const handleChange = (key: UserLangEnum, text: string) => {
    setDataList(last => last.map(l => ({ ...l, text: l.key === key ? text : l.text })))
  };

  const handleAdd = (key: UserLangEnum, text: string) => {
    let info: DictInfoVal = {
      key,
      value: text
    };
    setLoading(key);
    addVal(DictEnum.PURCHASE_RULE, info)
      .then(res => {
        notification.success({ message: t('common.saveOk') });
        setPurchaseRule([...purchaseRule, res]);
      })
      .catch(err => {
        notification.error({ message: t('common.saveFAil') });
      })
      .finally(() => setLoading(undefined))
  };

  const handleSave = (key: UserLangEnum, text: string) => {
    let info: DictInfoVal = {
      key,
      value: text
    };
    let id = purchaseRule.find(p => p.key === key)?.id ?? ''
    setLoading(key);
    updateVal(id, info)
      .then(res => {
        notification.success({ message: t('common.saveOk') });
        setPurchaseRule(purchaseRule.map(l => ({ ...l, value: l.id === id ? text : l.value })));
      })
      .catch(err => {
        notification.error({ message: t('common.saveFAil') });
      })
      .finally(() => setLoading(undefined))
  };

  return (
    <Flex vertical style={{ width: "100%", height: "70vh" }} gap={10}>
      <Flex justify="space-between" >
        <Typography.Title style={{ margin: 0 }} level={5}>{t('layout.purchaseRule')}</Typography.Title>
        <PDFGenerator previewMode
          selectedRows={[previewPurData]}
          handleStart={() => { }}
          handleEnd={() => { }}
          handleOk={() => { }}
        />
      </Flex>
      <div style={{ flex: 1, overflow: "auto" }}>
        {dataList.map(({ key, text }) => {
          let originRule = purchaseRule.find(p => p.key === key);
          let title = key === UserLangEnum.ZH ? "简体中文"
            : key === UserLangEnum.TR ? "繁體中文"
              : key === UserLangEnum.VN ? "Tiếng Việt"
                : key === UserLangEnum.EN ? "English"
                  : "한국인"
          let placeholder = key === UserLangEnum.ZH ? "请输入简体中文采购条约"
            : key === UserLangEnum.TR ? "請輸入繁體中文採購條約"
              : key === UserLangEnum.VN ? "Vui lòng nhập điều khoản mua hàng bằng tiếng Việt"
                : key === UserLangEnum.EN ? "Please enter purchase terms in English"
                  : "한국어로 구매 조항을 입력하세요"
          return (
            <PurchaseRuleBox>
              <div className="rule-title">{title}:</div>
              <Input.TextArea
                value={text}
                onChange={e => handleChange(key, e.target.value)}
                autoSize={{ minRows: 4, maxRows: 4 }}
                placeholder={placeholder}
              />
              <Flex justify="flex-end" className="btn-bottom">
                {!!!originRule && <Button loading={loading === key} type="primary" onClick={() => handleAdd(key, text)} disabled={!!!text} >{t('common.save')}</Button>}
                {!!originRule && originRule.value !== text && <Button loading={loading === key} type="primary" onClick={() => handleSave(key, text)} >{t('common.save')}</Button>}
              </Flex>
            </PurchaseRuleBox>
          )
        })}
      </div>
    </Flex>
  )
};

export default PurchaseRules;